import { EducatorPageChrome } from "@/pages/educators/page-chrome"
import { useId } from "react"

import { PageBody } from "@/components/ui/layout"
import { SaveButton } from "@/components/shared/action-buttons"

import ListingProfileForm from "./form"
import { useFormProps } from "./page-props"
import { EducatorsListingProfilesTeamListingProfileForm } from "@/types/serializers"
import { useNavigate } from "@/lib/page-rendering"

export default function Edit() {
  const navigate = useNavigate()
  const formId = useId()
  const titleId = useId()
  const { listing_profile } = useFormProps()
  const onSubmit = (data: {
    listing_profile: EducatorsListingProfilesTeamListingProfileForm
  }) => {
    navigate({
      href: ".",
      method: "put",
      data: data,
    })
  }

  return (
    <>
      <EducatorPageChrome
        titleId={titleId}
        identity={{ name: listing_profile.name }}
        action={<SaveButton form={formId} />}
      />
      <PageBody>
        <ListingProfileForm
          formId={formId}
          titleId={titleId}
          onSubmit={onSubmit}
        />
      </PageBody>
    </>
  )
}
